<template>
    <div v-bind:class="{'effect-moveIn' : true, 'effect-moveOut' : false }" class="basket-item-container col-12 rewardpoints">
        <div class="row">
            <div class="col-12 rewardpoints-caption">
                <translate item="redeemrewardpoints" fallback="WISSEL JE PUNTEN IN" ></translate>
            </div>
        </div>
        <div class="row row-reward-quantity" v-if="!this.cart.model.useRewardPoints">

            <div class="quantity  col">
                <span class="icon-basket-wrapper"><span class="icon-basket-img"><span class="icon-basket-count">{{freeProductCounts}}</span></span></span>

                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod != 'ordertotal' && freeProductCounts == 1"> <translate item="rewardpointsFreeProduct" fallback="Gratis broodje beschikbaar"></translate> </span>
                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod != 'ordertotal' && freeProductCounts > 1"><translate item="rewardpointsFreeProducts" fallback="Gratis broodjes beschikbaar"></translate></span>

                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod == 'ordertotal' && freeProductCounts == 1"> <translate item="rewardpointAvailable" fallback="Punt beschikbaar"></translate> </span>
                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod == 'ordertotal' && freeProductCounts > 1"><translate item="rewardpointsAvailable" fallback="Punten beschikbaar"></translate></span>

               

            </div>

            <div class="text-right col col-btn">
                 <span class="btn btn-link btn-success  d-inline-block d-sm-none " v-on:click="toggleRewardPoints(1)"><i class="icon-apply"></i></span>
                <span class="btn btn-link btn-success d-none d-sm-inline-block" v-on:click="toggleRewardPoints(1)"><i class="icon-apply inline"></i>TOEPASSEN</span>
            </div>

        </div>
        <div class="row row-reward-quantity" v-if="this.cart.model.useRewardPoints">
            <div class="quantity col">
                <span class="icon-basket-wrapper"><span class="icon-basket-img"><span class="icon-basket-count">{{freeProductCounts}}</span></span></span>

                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod != 'ordertotal' && freeProductCounts == 1"><translate item="rewardpointsFreeProductApplied" fallback="Gratis broodje toegepast"></translate></span>
                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod != 'ordertotal' && freeProductCounts > 1"><translate item="rewardpointsFreeProductsApplied" fallback="Gratis broodjes toegepast"></translate></span>

                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod == 'ordertotal' && freeProductCounts == 1"><translate item="rewardpointApplied" fallback="Punt toegepast"></translate></span>
                <span class="rewardpoints-apply-caption" v-if="this.cart.model.rewardPointsRedemptionMethod == 'ordertotal' && freeProductCounts > 1"><translate item="rewardpointsApplied" fallback="Punten toegepast"></translate></span>

            </div>
            <div class="text-right col col-btn">
                <span class="btn btn-link btn-danger  d-inline-block d-sm-none " v-on:click="removeDiscount(1)"><i class="icon-remove-coupon-code"></i></span>
                <span class="btn btn-link btn-danger  d-none d-sm-inline-block" v-on:click="removeDiscount(1)">  <i class="icon-remove-coupon-code inline"></i> <translate item="rewardpointsRemoveDiscount" fallback="Korting verwijderen"></translate></span>
            </div>
        </div>
    </div>
</template>

<script>

    import shoppingCartService from '../Services/ShopingCartService';
   
    import translate from './translate';

    export default {

        props: { "cart": Object },
        components: {  translate },
        methods: {

            toggleRewardPoints: function () {
                shoppingCartService.setUseRewardPoints(this.cart.model.rewardPointsToUse);
            },
            removeDiscount: function () {
                shoppingCartService.setUseRewardPoints(0);
            }
        },
        computed: {
            freeProductCounts: function () {
                if (this.cart.model.rewardPointsRedemptionMethod == 'ordertotal') {
                    return this.cart.model.rewardPointsToUse;
                } else {
                    return this.cart.model.rewardPointsToUse / this.cart.model.minimumRewardPointsToUse;
                }
                
            }
         
        }
    }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/amz-cart-rewardpoints.vue